<template>
  <v-flex sm6 md4 d-flex justify-center>
    <v-autocomplete
      v-model="model"
      :loading="loading"
      :items="items"
      :search-input.sync="term"
      class="mt-2"
      flat
      solo
      hide-details
      label="Search ..."
      append-icon="search"
      clearable
      :filter="() => true"
      @blur="handleBlur"
    >
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-tile-content v-text="data.item"></v-list-tile-content>
        </template>

        <template v-else>
          <template v-if="data.item.type === resultType.insurance">
            <v-list-tile-content>
              <v-list-tile-title>
                <v-icon
                  size="20"
                  color="light-green darken-3"
                  class="pr-2"
                  v-if="data.item.status === 1"
                >
                  done_all
                </v-icon>

                <v-icon
                  size="20"
                  color="red darken-3"
                  class="pr-2"
                  v-else-if="data.item.status === 4"
                >
                  remove_circle_outline
                </v-icon>

                <v-icon
                  size="20"
                  color="grey darken-2"
                  class="pr-2"
                  v-else-if="data.item.status === 0"
                >
                  inbox
                </v-icon>

                <strong>{{ data.item.internalId }}</strong>
                ,
                <span class="grey--text text--darken-1">{{ data.item.product }}</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </template>

          <template v-else-if="data.item.type === resultType.customer">
            <v-list-tile-title>
              <v-icon size="20" color="grey" class="pr-2">face</v-icon>
              <strong>{{ data.item.fullName }}</strong>
              ,
              <span class="grey--text text--darken-1">{{ data.item.ssn }}</span>
            </v-list-tile-title>
          </template>

          <template v-else-if="data.item.type === resultType.invoice">
            <v-list-tile-title>
              <v-icon size="20" color="grey" class="pr-2">attach_money</v-icon>
              OCR&nbsp;
              <strong>{{ data.item.ocr }}</strong>
            </v-list-tile-title>
          </template>
        </template>
      </template>
    </v-autocomplete>
  </v-flex>
</template>

<style scoped>
>>> .v-input__slot {
  background-color: rgba(0, 0, 0, 0.15) !important;
}
>>> .v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
  transform: none;
}
>>> i.primary--text {
  color: white !important;
}
</style>

<script>
import { getErrorMessage } from '../errorHandlers';
import debounce from 'lodash.debounce';

const SearchResultType = {
  insurance: 1,
  customer: 2,
  invoice: 3,
};

export default {
  data() {
    return {
      term: '',
      model: null,
      loading: false,
      resultType: SearchResultType,
      items: [],
    };
  },

  methods: {
    handleBlur() {
      this.items = [];
    },
  },

  watch: {
    term: debounce(async function(term) {
      // Max number of search results should be limited for clearer UX and performance.
      // api request must be fast as it is called frequently.
      // eslint-disable-next-line
      try {
        if (!term) {
          return;
        }
        this.loading = true;
        const {
          data: { insurances = [], customers = [], invoices = [] },
        } = await this.$http.get(`/api/search?q=${term}&take=5`);

        this.items = [];

        if (insurances.length) {
          this.items.push(
            { header: 'Insurances' },
            ...insurances.map((i) => ({ ...i, type: SearchResultType.insurance })),
          );
        }

        if (customers.length) {
          this.items.push(
            { header: 'Customers' },
            ...customers.map((c) => ({ ...c, type: SearchResultType.customer })),
          );
        }

        if (invoices.length) {
          this.items.push(
            { header: 'Invoices' },
            ...invoices.map((c) => ({ ...c, type: SearchResultType.invoice })),
          );
        }
      } catch (e) {
        this.errorMessage = getErrorMessage(e);
      } finally {
        this.loading = false;
      }
    }, 250),

    model(value) {
      if (value) {
        const urlMap = {
          [SearchResultType.insurance]: `/contract/${value.internalId}`,
          [SearchResultType.customer]: `/customers/${value.id}`,
          [SearchResultType.invoice]: `/contract/${value.insurance_id}`,
        };
        this.$router.push(urlMap[value.type]);

        // clear search model as we navigate to result page once result is selected
        // this changes normal behaviour of vuetify autocomplete
        this.$nextTick(() => {
          this.model = null;
        });
      }
    },
  },
};
</script>
